import { MessageIcons } from '@_shared/icons';

export const ERRORLIST = [
	{
		status: -1,
		title: '죄송합니다.\n서버에 오류가 있습니다.',
	},
	{
		status: 401,
		title: '죄송합니다.\n페이지에 접근할 수 없습니다.',
		message:
			'해당 페이지에 접근할 수 있는 권한이 없습니다.\n문제가 계속되면 관리자에게 문의해주세요.',
	},
	{
		status: 404,
		title: '죄송합니다.\n페이지를 찾을 수 없습니다.',
		message:
			'존재하지 않는 주소를 입력하셨거나\n요청하신 페이지의 주소가 변경, 삭제되어 찾을 수 없습니다.\n주소를 다시 확인해주세요.',
		Icon: <MessageIcons.ErrorMessage404Icon />,
	},
	{
		status: 500,
		title: '죄송합니다.\n서버에 오류가 있습니다.',
		message:
			'요청하신 페이지에 오류가 발생하였습니다.\n문제가 계속되면 관리자에게 문의해주세요.',
		Icon: <MessageIcons.ErrorMessage500Icon />,
	},
];

export function getStaticError(status: number) {
	const findError = ERRORLIST.find((ERROR) => ERROR.status === status);

	return findError !== undefined ? findError : ERRORLIST[0];
}
